// @mui material components
import { Card, Grid, Icon, Divider } from "@mui/material";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
// import MDInput from "theme/components/MDInput";
import MDTypography from "theme/components/MDTypography";
// import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

import { useNavigate } from "react-router-dom";

function ToolsHomePage() {
  const pageTitle = "Tools";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={10}>
        <MDBox m={2} display="flex" justifyContent="space-between">
          <MDBox>
            <MDTypography variant="h6" fontWeight="bold" align="center">
              Tools
            </MDTypography>
          </MDBox>
          <MDBox>
            <MDTypography variant="h6">
              <Icon color="dark">apps</Icon>
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox>
          <Divider />
        </MDBox>
        <MDBox mt={3}>
          <MDBox>
            <MDBox>
              <Grid container spacing={{ xs: 3, md: 3, lg: 3 }}>
                <Grid item xs={12}>
                  <Card>
                    <MDBox
                      p={2}
                      onClick={() => {
                        navigate("/gps-camera");
                      }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <MDBox>
                        <MDBox>
                          <MDTypography variant="h6">GPS Camera</MDTypography>
                        </MDBox>
                        <MDBox>
                          <MDTypography variant="subtitle2" fontSize={14}>
                            Capture and save geo-tagged images.
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                      <MDBox mt={2}>
                        <Icon color="dark">camera_alt</Icon>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ToolsHomePage;
